import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormBuilder } from '@angular/forms';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BonusService } from '../app-myaccount/bonuses/services/bonus.service';
import { EmitterService } from '../services/emitter.service';
import { PnpZimplerService } from '../services/pnp-zimpler.service';
import { UserDetailsService } from '../services/user-details.service';
import { CustomValidators } from '../shared/utility/custom-validator';
import { Utility } from '../shared/utility/utility';
import { CountryDataService } from '../services/country.service';
import { CashierService } from '../cashier/services/cashier.service';
import { CASHIER_TYPES, CUSTOM_AMOUNT_ONE, CUSTOM_AMOUNT_THREE, CUSTOM_AMOUNT_TWO } from '../cashier/config/cashier.config';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-zimpler-quickdeposit',
  templateUrl: './zimpler-quickdeposit.component.html',
  styleUrls: ['./zimpler-quickdeposit.component.scss']
})
export class ZimplerQuickdepositComponent implements OnInit, OnDestroy {


  zimplerQuickDepositForm = this.formBuilder.group({
    'amount': ['', [this.customValidators.required]],
    'bonusCode': [null]
  });
  bonusCode: any
  addBonus: boolean = false;
  predefineAmounts = [CUSTOM_AMOUNT_ONE, CUSTOM_AMOUNT_TWO, CUSTOM_AMOUNT_THREE];
  depositAmount: any = this.predefineAmounts[1];
  currencySymbol: any = this.userDetailsService.getZimplerDefaultCurrencySybmol();
  langCode: string;
  destroy$: Subject<boolean> = new Subject<boolean>();
  amountInvalid = false;
  otherAmount: any;
  validAmounts: any = {};
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaPath = environment.mediaPath;
  showCurrencySymbol: boolean = false;
  isUserLoggedIn: boolean;
  userInfo: any;
  countryIP: any;
  isPnpFlow: boolean;
  userCurrency;
  isLoading = true;
  byclickingDesposit;
  siteCode= environment.website_code;
  cashierAmountsConfig = [];
  constructor(private formBuilder: UntypedFormBuilder,
    private customValidators: CustomValidators,
    private pnpService: PnpZimplerService,
    private bonusService: BonusService,
    private userDetailsService: UserDetailsService,
    private emitterService: EmitterService,
    public utils: Utility,
    private countryDataService: CountryDataService,
    private cashierService:CashierService,
    private translateService:TranslateService,
    private router:Router
    ) {
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
    this.emitterService.triggerQuickDeposit$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
        this.quickDeposit();
    });
    this.emitterService.cashierInputConfigData$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
        console.log(data)
    });
  }

  ngOnInit() {
    this.byclickingDesposit = this.translateService.instant("quickDeposit.byclickingDesposit1");
    this.isUserLoggedIn = this.utils.isUserLoggedIn()?this.utils.isUserLoggedIn():false;
    this.userCurrency = this.userDetailsService.getUserCurrencySymbol();
    this.userInfo = this.isUserLoggedIn ? this.userDetailsService.getUserProfileDetails() : null;
    this.countryIP = this.userInfo && this.userInfo['country'] ? this.userInfo['country'] :this.countryDataService.IPCountry ? this.countryDataService.IPCountry.toUpperCase() : "";
    if(!this.countryIP){
      this.countryIP = this.countryDataService.IPCountry
    }
    this.isPnpFlow = environment.zimplerCountries.indexOf(this.countryIP)>=0 ? true : false;
    this.getPNPMinMaxTxnLimits();
    this.getCustomAmount(CASHIER_TYPES.TRANSACTION_DEPOSIT,this.userDetailsService.getCurrencyCode());
  }
  getCustomAmount(type, currency) {
    this.cashierService
      .getCashierAmountConfig(type, currency)
      .subscribe((res: any) => {
        if (res && res[0] && res[0].amounts && res[0].amounts.length && res[0].amounts.length >= 3) {
            //sort amounts
            res[0].amounts = res[0].amounts.sort(function (a, b) {return a - b;});
            this.predefineAmounts = res[0].amounts;
            this.depositAmount = this.predefineAmounts[1];
            this.cashierService.customCashierAmountInputs = this.cashierAmountsConfig;
            this.isLoading = false;
        } else {
            this.updateDefaultValues();
            this.isLoading = false;
        }
      }, error=>{
        this.isLoading = false;
      });
  }
  updateDefaultValues() {
   this.predefineAmounts = [CUSTOM_AMOUNT_ONE, CUSTOM_AMOUNT_TWO, CUSTOM_AMOUNT_THREE];
   this.depositAmount = this.predefineAmounts[1]
  }
  getValueForTab(value){
    if(this.isUserLoggedIn){
      return this.userDetailsService.getUserFormatedBalence(value)
    }
    return this.currencySymbol+" "+value
  }
  getPNPMinMaxTxnLimits() {
    

    let minMaxRequestData = {
      option: this.isPnpFlow ? "BRITEPLAY": "ZIMPLER_DIRECT",
      currency: 'EUR'
    }
    this.pnpService.getPNPMinMaxTxnLimits(minMaxRequestData)
      .then(data => {
        if (data && data['minLimit'] && data['maxLimit']) {
          this.validAmounts = data;
          this.setTransactionAmount(this.predefineAmounts[1]);
        }
      });
  }

  setTransactionAmount(depositamount) {
    if (depositamount) {
      this.depositAmount = depositamount;
      if(this.otherAmount || this.zimplerQuickDepositForm.controls["amount"].value) {
        this.otherAmount=null;
        this.showCurrencySymbol = false;
        this.zimplerQuickDepositForm.controls["amount"].setValue(this.otherAmount);
      }
      this.checkValid(this.depositAmount);

    }
  }

  onChangeEvent(event: any){
    this.depositAmount = event.target.value;
    this.otherAmount = this.depositAmount;
    this.checkValid(this.depositAmount)
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onFocus(){
    this.showCurrencySymbol = true;
  }

  onFocusOut(){
    if(!this.otherAmount) this.showCurrencySymbol = false;
    
  }

  checkValid(amount) {
    if(amount >= this.validAmounts['minLimit'] && amount <= this.validAmounts['maxLimit']){
      this.amountInvalid = false;
      return;
    }
    this.amountInvalid = true;
  }

  quickDeposit() {
    localStorage.setItem('isQuickDeposit','true');
    this.amountInvalid = false;
    this.zimplerQuickDepositForm.controls["amount"].setValue(this.depositAmount);
    if (this.zimplerQuickDepositForm.valid) {
      this.cashierService.isQuickDepositClicked = true;
      this.cashierService.quickDepositSelectionAmount = this.zimplerQuickDepositForm.controls['amount'].value;
      if (this.bonusCode) this.bonusService.setEligibleBonusCode({ bonusCode: this.bonusCode });

      this.pnpService.broadCastInitQuickDeposit(this.zimplerQuickDepositForm.value);

      if (this.userDetailsService.checkZimplerDepositOpen()) {
        this.pnpService.openZimplerDeposit();
      }

      this.resetFormValuesAndBonusCode();
    } else {
      this.amountInvalid = true;
    }
  }

  hideShowBonusField() {
    this.addBonus = !this.addBonus;
    if (this.bonusCode) this.bonusCode = null;
  }

  resetFormValuesAndBonusCode() {
    this.bonusCode = null;
    this.zimplerQuickDepositForm.reset();
    this.setTransactionAmount(this.predefineAmounts[1]);
    this.addBonus = false;
    this.amountInvalid = false;
    this.otherAmount=null;
  }

  ngOnDestroy() {
    this.resetFormValuesAndBonusCode();
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }


}
